/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `top` - top
 * `center` - center
 * `bottom` - bottom
 * `lower` - lower
 */
export type VisualizerPositionEnum =
  (typeof VisualizerPositionEnum)[keyof typeof VisualizerPositionEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VisualizerPositionEnum = {
  top: "top",
  center: "center",
  bottom: "bottom",
  lower: "lower",
} as const;
